<p-paginator *ngIf="seen"
             [rows]="this.state.pageSize"
             [totalRecords]="computePages"
             [alwaysShow]="false"
             [first]="currentPage"
             (onPageChange)="setPage($event)">
</p-paginator>
